module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "d-flex align-items-center justify-content-between"
  }, [_c('p', {
    staticClass: "d-flex mr-2"
  }, [_vm._v(" " + _vm._s(_vm.description))]), _vm._v(" "), _c('div', {
    staticClass: "buttons d-inherit"
  }, [_c('button', {
    staticClass: "button",
    class: {
      'is-danger': !_vm.value, 'is-light': _vm.value, 'is-loading': _vm.loading && _vm.value
    },
    on: {
      "click": function($event) {
        _vm.saveValue(false)
      }
    }
  }, [_vm._v("OFF")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    class: {
      'is-success': _vm.value, 'is-light': !_vm.value, 'is-loading': _vm.loading && !_vm.value
    },
    on: {
      "click": function($event) {
        _vm.saveValue(true)
      }
    }
  }, [_vm._v("ON")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-49660774"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmailSettingField.vue
// module id = 1025
// module chunks = 0